// extracted by mini-css-extract-plugin
export default {"mainWrapper":"style_mainWrapper__lNpof","textWrapper":"style_textWrapper__LFbEx","iconWrapper":"style_iconWrapper__EiEx3"};